import React from 'react';
import { Link } from 'react-router-dom';
import TagManagerService from 'services/TagManager';
import { preFooterTxt } from 'config/translate/variables';
import style from './style.scss';//NOSONAR

const PreFooter = () => {

    const clickPreFooterInfo = (action, tag) => {
        TagManagerService.homeBody(action, tag);
    }

    return (
        <section className="prefooter">
            <div className="center">
                <Link to="/institucional/preguntas-frecuentes/preguntas-frecuentes#3" onClick={() => clickPreFooterInfo('Como comprar', window.location.href)} className="prefooter-link mobile-click">
                    <div className="jumbo-icon-faq"></div>
                    <div className="text-wrapper">
                        <h2 className="title">{preFooterTxt.faq.title}</h2>
                        <h3 className="text">{preFooterTxt.faq.subtitle}</h3>
                    </div>
                </Link>
                <Link to="/institucional/locales-jumbo" onClick={() => clickPreFooterInfo('Nuestros Locales', window.location.href)} className="prefooter-link mobile-click">
                    <div className="jumbo-icon-places"></div>
                    <div className="text-wrapper">
                        <h2 className="title">{preFooterTxt.stores.title}</h2>
                        <h3 className="text">{preFooterTxt.stores.subtitle}</h3>
                    </div>
                </Link>
                <Link to="/institucional/servicios" onClick={() => clickPreFooterInfo('Entregas', window.location.href)} className="prefooter-link mobile-click">
                    <div className="jumbo-icon-delivery"></div>
                    <div className="text-wrapper">
                        <h2 className="title">{preFooterTxt.delivery.title}</h2>
                        <h3 className="text">{preFooterTxt.delivery.subtitle}</h3>
                    </div>
                </Link>
                <Link to="/institucional/preguntas-frecuentes/preguntas-frecuentes#5" onClick={() => clickPreFooterInfo('Pagos', window.location.href)} className="prefooter-link mobile-click">
                    <div className="jumbo-icon-payment"></div>
                    <div className="text-wrapper">
                        <h2 className="title">{preFooterTxt.payment.title}</h2>
                        <h3 className="text">{preFooterTxt.payment.subtitle}</h3>
                    </div>
                </Link>
            </div>
        </section>
    )
}

export default PreFooter;
